import { createSlice } from '@reduxjs/toolkit';

/**
 * Auth Slice — Local auth state
 *
 * RTK Query (authApi.getMe) is the source of truth for user data.
 * This slice tracks derived state like "has auth been checked" and
 * "is the user currently authenticated" for preventing flash-of-login-page.
 *
 * FIX: selectIsAuthenticated now reads from Redux state instead of
 * localStorage directly — reading localStorage inside a selector
 * doesn't trigger React re-renders.
 */
const initialState = {
  isInitialized: false,
  isAuthenticated: !!localStorage.getItem('accessToken'),
  activeWorkspaceId: localStorage.getItem('activeWorkspaceId') || null,
  lastLoginAt: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setInitialized: (state) => {
      state.isInitialized = true;
    },
    setAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setActiveWorkspace: (state, action) => {
      state.activeWorkspaceId = action.payload;
      if (action.payload) {
        localStorage.setItem('activeWorkspaceId', action.payload);
      } else {
        localStorage.removeItem('activeWorkspaceId');
      }
    },
    setLastLogin: (state, action) => {
      state.lastLoginAt = action.payload;
    },
    clearAuth: (state) => {
      state.isInitialized = false;
      state.isAuthenticated = false;
      state.activeWorkspaceId = null;
      state.lastLoginAt = null;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('activeWorkspaceId');
    },
  },
});

export const {
  setInitialized,
  setAuthenticated,
  setActiveWorkspace,
  setLastLogin,
  clearAuth,
} = authSlice.actions;

// Selectors — all read from Redux state, NOT localStorage
export const selectIsInitialized = (state) => state.auth.isInitialized;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectActiveWorkspaceId = (state) => state.auth.activeWorkspaceId;

export default authSlice.reducer;
